// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__32QuO","checkboxCol":"Table_checkboxCol__2FJPq","emailCol":"Table_emailCol__1ratY","actionCol":"Table_actionCol__3R-0H"};